
import {
    mapState,
    mapActions,
} from 'vuex'
import viewName from '../constant.js'
import { SubmitBar, CountDown, Dialog } from 'vant'
import { getOrderInfo } from '../../models/marketingConfirmOrder'
import { createOrder } from '../../models/marketingActivities'
import {
    getLocalConfig,
    setLocalConfig
} from '@/utils/session'
import { postZeroPay } from '@/models/confirmOrder'

export default {
    name: viewName.marketingConfirmOrder,
    inject: ['showLoading', 'hideLoading'],
    components: {
        [SubmitBar.name]: SubmitBar,
        [CountDown.name]: CountDown,
        [Dialog.name]: Dialog,
    },
    data () {
        return {
            sstore_logo: '', // 门店图标
            sstore_name: '', // 门店名称
            package_name: '', // 营销活动名称
            create_time: '', // 创建时间
            indate_time: '', // 有效期
            price: '', // 活动金额
            activity_count: '', // 活动个数
            package_id: '', // 营销活动id
            sstore_id: '', // 门店id
            coupon_count: '', // 已领取的优惠券数量
            coupon_price: '', // 优惠券金额
            distribution_code: '', // 标识码
            // count_down_time: 0, // 倒计时
            leavePage: false,
            selectCoupon: {},
        }
    },
    // filters: {
    //     addZero (value) {
    //         return value > 9 ? value : `0${value}`
    //     }
    // },
    computed: {
        ...mapState({

        }),
        // btnText () {
        //     if (this.count_down_time <= 0) {
        //         return '支付超时'
        //     } else {
        //         return '去付款'
        //     }
        // },
        // btnDisabled () {
        //     if (this.count_down_time <= 0) {
        //         return true
        //     } else {
        //         return false
        //     }
        // },
    },
    created () {},
    activated () {
        this.leavePage = false
        Object.assign(this, this.$route.query)

        this.setAppClass({
            isAppend: true,
            className: 'bgGreyColor'
        })
        this.$emit('setHeader', {
            title: '订单确认',
            showHeader: true,
            showLeft: true,
        })
        this.selectCoupon = getLocalConfig('SELECT_COUPON')
        this.getData()
    },
    deactivated () {
        this.leavePage = true
    },
    mounted () {
    },
    methods: {
        ...mapActions([
            'setAppClass'
        ]),
        async getData () {
            try {
                this.showLoading()
                const { user_coupon_id } = this.selectCoupon
                const { package_id, sstore_id } = this
                const data = await getOrderInfo({package_id, sstore_id, user_coupon_id})
                // data.count_down_time = data.count_down_time * 1000
                Object.assign(this, data)
                this.hideLoading()
            } catch (err) {
                console.log(err)
                this.hideLoading()
            }
        },
        // 倒计时结束时触发
        // onFinish () {
        //     if (this.count_down_time && !this.leavePage) {
        //         this.count_down_time = 0
        //         Dialog.alert({
        //             message: '<div class="overTime">支付超时，该订单已失效</div><div class="newBuy">请重新选择活动购买</div>',
        //             confirmButtonText: '重新下单',
        //             confirmButtonColor: '#fc2d2d',
        //             className: 'marketingConfirmOrder-dialog'
        //         }).then(() => {
        //             this.$router.push({
        //                 path: '/marketingActivities',
        //                 query: {
        //                     sstore_id: this.sstore_id,
        //                     package_id: this.package_id,
        //                     distribution_code: this.distribution_code
        //                 }
        //             })
        //         })
        //     }
        // },
        // 去付款
        async goPay () {
            try {
                this.showLoading()
                const { user_coupon_id } = this.selectCoupon
                // 创建订单
                const data = await createOrder({
                    package_id: this.package_id,
                    sstore_id: this.sstore_id,
                    distribution_code: this.distribution_code,
                    user_coupon_id
                })
                if (Number(this.price) > 0) {
                    // 跳转选择支付页面
                    this.$router.replace({
                        path: '/chooseToPay',
                        query: {
                            order_id: data.order_id,
                            sstore_id: this.sstore_id,
                            package_id: this.package_id,
                            distribution_code: this.distribution_code
                        }
                    })
                } else {
                    let params = {
                        order_id: data.order_id,
                        order_type: 'service_package',
                    }
                    // 进行0元支付
                    await postZeroPay(params)
                    this.$router.push({
                        name: 'activityPayResult',
                        query: {
                            order_id: data.order_id
                        }
                    })
                }
                this.hideLoading()
            } catch (err) {
                console.log(err)
                this.hideLoading()
            }
        },
        // 选择优惠券
        toUserCoupon () {
            this.$router.push({
                name: 'userCoupon',
                query: {
                    sstore_id: this.sstore_id,
                    // coupon_id: '',
                    from: 'marketingConfirmOrder',
                    package_id: this.package_id,
                }
            })
        },
    },
    destroyed () {

    },
    beforeRouteLeave (to, from, next) {
        if (to.name !== 'userCoupon' && to.name !== 'chooseToPay') {
            setLocalConfig('SELECT_COUPON', '')
        }
        next()
    }
}
